const base = (size) => ({
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
});

export const SearchIcon = ({ size = 14 }) => (
  <svg {...base(size)}><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>
);

export const RefreshIcon = ({ size = 14 }) => (
  <svg {...base(size)}>
    <polyline points="23 4 23 10 17 10" /><polyline points="1 20 1 14 7 14" />
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
  </svg>
);

export const ClockIcon = ({ size = 16 }) => (
  <svg {...base(size)}><circle cx="12" cy="12" r="9" /><polyline points="12 7 12 12 15.5 14" /></svg>
);

export const EditIcon = ({ size = 13 }) => (
  <svg {...base(size)}><path d="M12 20h9" /><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" /></svg>
);

export const HomeIcon = ({ size = 16 }) => (
  <svg {...base(size)}><path d="M3 9.5 12 3l9 6.5V21H3z" /><path d="M9 21v-7h6v7" /></svg>
);

export const CloseIcon = ({ size = 14 }) => (
  <svg {...base(size)}><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
);

export const InfoIcon = ({ size = 14 }) => (
  <svg {...base(size)}><circle cx="12" cy="12" r="9" /><line x1="12" y1="11" x2="12" y2="16.5" /><line x1="12" y1="7.5" x2="12" y2="7.5" /></svg>
);

export const BoltIcon = ({ size = 16 }) => (
  <svg {...base(size)}><polygon points="13 2 4 14 11 14 10 22 20 10 13 10 13 2" /></svg>
);
